import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Column, Columns, Inline, renderChildren } from '@superdispatch/ui';
import { ReactNode } from 'react';
import { CarrierInfoAvatar } from 'shared/modules/carrier-profile/core/CarrierInfoAvatar';
import { VerificationBadge } from 'shared/modules/carrier-profile/core/VerificationBadge';
import { useCarrierInfo } from 'shared/modules/carrier-profile/data/CarrierInfoAPI';
import { useVerifiedCarrierApplicationStatus } from 'shared/modules/carrier-profile/data/VerifiedCarrierApplicationStatusAPI';

interface HeaderWrapperProps {
  children: ReactNode;
  isVerified?: boolean;
}

function HeaderWrapper({ children, isVerified }: HeaderWrapperProps) {
  return isVerified ? (
    <Inline verticalAlign="center" space="xxsmall">
      {children}
    </Inline>
  ) : (
    renderChildren(children)
  );
}

export function CarrierProfileWebviewHeader() {
  const { data: carrierInfo } = useCarrierInfo();
  const { data } = useVerifiedCarrierApplicationStatus();
  const isVerified = data?.verified_carrier_application?.status === 'approved';

  return (
    <Columns space="small" align="center">
      <Column width="content">
        <CarrierInfoAvatar size="large" />
      </Column>
      <Column>
        {carrierInfo ? (
          <HeaderWrapper isVerified={isVerified}>
            <Typography variant="h5">{carrierInfo.name}</Typography>
            <VerificationBadge />
          </HeaderWrapper>
        ) : (
          <Skeleton width="300px" height="40px" />
        )}
      </Column>
    </Columns>
  );
}
